/*
 * MatchaPro storefront fixes.
 *
 * FIX 1 — Add-to-cart inside product cards: stop the card's whole-card navigation from
 * hijacking clicks on the embedded add-to-cart form.
 * FIX 2 — Home video (section_RhpYRt): hide poster on play; remove focus outline (stroke).
 * FIX 3 — Hide the redundant quick-add "+" on mobile card carousels.
 * FIX 4 — Product image (desktop): cap the square media gallery to the viewport height.
 * FIX 5 — Product image (mobile): 88% width, centered, rounded corners.
 * FIX 6 — Product-card carousels (product page "recommendations", home "best sellers", cart):
 * padding-inline matches --page-width so carousel aligns with page content; overflow hidden clips cards.
 * Desktop only (min-width 750px); mobile unchanged.
 * FIX 7 — Home "best sellers" carousel on mobile: show one full-width card per view.
 * FIX 8 — Collection banner (desktop): taller section + better image crop; mobile unchanged.
 * FIX 9 — Mega menu de escritorio: se queda abierto hasta salir o pulsar (06/08/2026).
 */
(function () {
  /* FIX 1 */
  document.addEventListener(
    'click',
    function (e) {
      var target = e.target;
      if (!target || !target.closest) return;
      var pfc = target.closest('product-form-component');
      if (!pfc || !pfc.closest('product-card')) return;
      if (!pfc.__mpAtcGuard) {
        pfc.__mpAtcGuard = true;
        pfc.addEventListener('click', function (ev) {
          ev.stopPropagation();
        });
      }
    },
    true
  );

  /* FIX 2 – 8 (injected stylesheet) */
  var css =
    '[id*="section_RhpYRt"] deferred-media:has(:focus-visible),' +
    '[id*="section_RhpYRt"] deferred-media:focus-visible,' +
    '[id*="section_RhpYRt"] deferred-media:focus-within,' +
    '[id*="section_RhpYRt"] video:focus,' +
    '[id*="section_RhpYRt"] video:focus-visible,' +
    '[id*="section_RhpYRt"] video { outline: none !important; }' +
    '[id*="section_RhpYRt"] deferred-media[data-media-loaded] .deferred-media__poster-button { display: none !important; }' +
    '@media (max-width: 749px) {' +
    '[id*="product_recommendations_iA6pyd"] product-card .quick-add,' +
    '[id*="product_list_4Nx7AB"] product-card .quick-add,' +
    '[id*="product_list_X8Q7bi"] product-card .quick-add { display: none !important; }' +
    '[id*="product_list_X8Q7bi"] slideshow-slide { min-width: 100% !important; width: 100% !important; }' +
    '[id*="product_list_X8Q7bi"] .resource-list--grid { grid-template-columns: 1fr !important; gap: 16px !important; }' +
    '}' +
    '@media screen and (min-width: 750px) {' +
    '#MainContent[data-template="product"] .media-gallery--carousel {' +
    'max-width: min(100%, calc(100svh - 220px)) !important;' +
    'margin-inline: auto !important;' +
    '}' +
    '}' +
    '@media screen and (max-width: 749px) {' +
    '#MainContent[data-template="product"] .media-gallery--carousel {' +
    'width: 88% !important;' +
    'margin-inline: auto !important;' +
    '}' +
    '#MainContent[data-template="product"] .product-media-container {' +
    'border-radius: 18px !important;' +
    '}' +
    '}' +
    '[id*="product_recommendations_iA6pyd"] slideshow-container,' +
    '[id*="product_recommendations_iA6pyd"] slideshow-component,' +
    '[id*="product_recommendations_iA6pyd"] .section-background { background: transparent !important; }' +
    '@media screen and (min-width: 750px) {' +
    '[id*="product_recommendations_iA6pyd"] .section > .force-full-width,' +
    '[id*="product_list_X8Q7bi"] .section > .force-full-width,' +
    '[id*="product_list_4Nx7AB"] .section > .force-full-width { grid-column: 1 / -1 !important; padding-inline: max(24px, calc((100% - var(--page-width, 1200px)) / 2)) !important; box-sizing: border-box !important; }' +
    '[id*="product_recommendations_iA6pyd"] slideshow-component.resource-list__carousel,' +
    '[id*="product_list_X8Q7bi"] slideshow-component.resource-list__carousel,' +
    '[id*="product_list_4Nx7AB"] slideshow-component.resource-list__carousel { overflow: hidden !important; }' +
    '}' +
    '@media screen and (min-width: 750px) {' +
    '#MainContent[data-template^="collection"] > .shopify-section:first-child .section { --section-min-height: 620px !important; }' +
    '#MainContent[data-template^="collection"] > .shopify-section:first-child .background-image-container img { object-fit: cover !important; object-position: center 50% !important; }' +
    '#MainContent[data-template^="collection"] .product-grid:has(> li:nth-child(3)) { grid-template-columns: repeat(3, 1fr) !important; gap: 28px !important; }' +
    '}' +
    '@media screen and (min-width: 1200px) {' +
    '#MainContent[data-template^="collection"] > .shopify-section:first-child .section { --section-min-height: 750px !important; }' +
    '}';
  var style = document.createElement('style');
  style.setAttribute('data-mp-video-fix', '');
  style.textContent = css;
  (document.head || document.documentElement).appendChild(style);
})();

/*
 * FIX 9 — MEGA MENU DE ESCRITORIO (06/08/2026)
 *
 * COMPORTAMIENTO PEDIDO: una vez abierto, el menu NO se cierra hasta que el
 * usuario pulsa algo o sale del todo de la zona del menu.
 *
 * POR QUE HACIA FALTA
 * El tema cierra el panel con on:pointerleave="/deactivate" en cada <li>. Como
 * el <li> solo ocupa el ancho de su texto, el panel se cerraba en tres
 * situaciones distintas:
 *   1. Al cruzar el hueco de 10px entre la barra y el panel.
 *   2. Durante los ~80ms que tarda el panel en volverse tocable (clip-path 0.36s).
 *   3. Al pasar por encima de otro boton del menu de camino a los enlaces, que
 *      estan alineados a la izquierda mientras los botones estan repartidos.
 * Los tres se manifiestan igual: "el menu se cae".
 *
 * COMO FUNCIONA
 *   a) deactivate() deja de cerrar por pointerleave. El cierre pasa a decidirlo
 *      la posicion real del raton.
 *   b) Se define una ZONA SEGURA = fila del header + alto del panel abierto, a
 *      todo el ancho. Mientras el raton este dentro, el menu sigue abierto.
 *   c) Se cierra al salir de esa zona, al hacer clic, al pulsar Escape o al
 *      sacar el raton de la ventana. Cuatro salidas, para que nunca se quede
 *      atascado abierto.
 *   d) Cambiar de menu exige intencion: rozar otro boton de paso no cambia el
 *      panel; hay que quedarse RETARDO_CAMBIO ms.
 *   e) El foco por teclado (blur) mantiene el comportamiento original del tema,
 *      para no romper la navegacion accesible.
 *
 * NOTA TECNICA
 * activate es un campo de instancia y deactivate vive en el prototipo; ambos se
 * sobrescriben por instancia. Funciona porque el sistema de bindings del tema
 * resuelve on:pointerenter="/activate" en el momento del evento y no en el
 * connectedCallback. Verificado en vivo antes de escribirlo.
 */
(function () {
  var RETARDO_CAMBIO = 180;
  var MARGEN = 10;

  function instalar(menu) {
    if (menu.__mpMenuFix) return;
    var activarOrig = menu.activate;
    var desactivarOrig = menu.deactivate;
    if (typeof activarOrig !== 'function' || typeof desactivarOrig !== 'function') return;
    menu.__mpMenuFix = true;

    var header = menu.closest('header-component');
    var fila = menu.closest('.header__row') || menu;
    var timerCambio = null;
    var pendienteRaf = false;
    var ultX = 0;
    var ultY = 0;

    function itemAbierto() {
      return menu.querySelector('[ref="menuitem"][aria-expanded="true"]');
    }

    function dentroDeLaZona(x, y) {
      var r = fila.getBoundingClientRect();
      var alto = 0;
      if (header) {
        alto = parseFloat(getComputedStyle(header).getPropertyValue('--submenu-height')) || 0;
      }
      return y >= r.top - MARGEN && y <= r.bottom + alto + MARGEN;
    }

    function cerrar() {
      clearTimeout(timerCambio);
      var item = itemAbierto();
      if (!item) return;
      desactivarOrig.call(menu, { target: item, type: 'mp-cierre', relatedTarget: null });
    }

    /* (d) cambiar de menu solo con intencion */
    menu.activate = function (event) {
      var li = event.target;
      var abierto = itemAbierto();
      var esCambio = abierto && li instanceof HTMLElement && abierto.parentElement !== li;
      if (!esCambio) {
        clearTimeout(timerCambio);
        return activarOrig(event);
      }
      clearTimeout(timerCambio);
      timerCambio = setTimeout(function () {
        if (li.matches(':hover')) activarOrig(event);
      }, RETARDO_CAMBIO);
    };

    /* (a) y (e) el pointerleave ya no cierra; el teclado si */
    menu.deactivate = function (event) {
      if (event && event.type === 'blur') {
        return desactivarOrig.call(menu, event);
      }
    };

    /* (b) y (c) el cierre lo decide la posicion del raton */
    document.addEventListener(
      'pointermove',
      function (e) {
        ultX = e.clientX;
        ultY = e.clientY;
        if (pendienteRaf || !itemAbierto()) return;
        pendienteRaf = true;
        requestAnimationFrame(function () {
          pendienteRaf = false;
          if (itemAbierto() && !dentroDeLaZona(ultX, ultY)) cerrar();
        });
      },
      { passive: true }
    );

    document.addEventListener('click', function () {
      if (itemAbierto()) cerrar();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && itemAbierto()) cerrar();
    });

    document.addEventListener('mouseleave', function () {
      if (itemAbierto()) cerrar();
    });
  }

  function instalarTodos() {
    document.querySelectorAll('header-menu').forEach(instalar);
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('header-menu').then(function () {
      requestAnimationFrame(instalarTodos);
    });
  } else {
    instalarTodos();
  }

  document.addEventListener('shopify:section:load', instalarTodos);
})();
